module.exports = __webpack_public_path__ + "static/media/Penaltykicks.76be81ad.gif";